<template>
  <LoginForm
    :body-text="'Please enter in your email address to request a password reset. A recovery link will then be emailed to you.'"
    :fields="fieldsToShow"
    :logo-url="expandedLogoUrl"
    :logo-default="'https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg'"
    :is-white-labeled="isWhiteLabeled"
    :submit-text="text"
    @submitted="reset"
    :data="this.$data"></LoginForm>
</template>

<script>
  import LoginForm from "@/components/auth/LoginForm";
  import { LoginClient } from "@/clients/Login";
  import { TenantClient } from "@/clients/Tenant";
  import CentralPasswordReset from "@/models/sis-central/CentralPasswordReset";
  import { mapGetters } from "vuex";

  export default {
    components: { LoginForm },
    name: "Login.forgotPassword",
    data() {
      return {
        text: "",
        tenant_id: this.$route.query.tenant_id || this.$cookies.get("tenant_id") || null,
        fieldsToShow: ["email", "go back"],
        tenants: null,
      };
    },
    computed: {
      ...mapGetters("tenant", ["expandedLogoUrl", "isWhiteLabeled"]),
    },
    mounted() {
      let text = this.tenant_id ? "Reset password" : "Continue";
      this.text = text;
    },
    methods: {
      async getTenants(email) {
        return await this.handleResponse(() => TenantClient.getTenants({ email: encodeURIComponent(email) }));
      },
      async reset({ email, tenant_id }) {
        if (this.$store.getters["tenant/isCentral"]) {
          CentralPasswordReset.ResetStep1({ email })
            .then(() => {
              this.isLoading = false;
              this.$buefy.dialog.alert({
                title: `Reset Link Sent`,
                confirmText: `I understand`,
                hasIcon: true,
                type: "is-primary",
                message: `A password reset link has been emailed to you. Please click the link and follow the steps as prompted. Remember to check your spam folder.`,
                onConfirm: () => this.$router.push("/login"),
              });
            })
            .catch(err => {
              if (err === "no-tenants") {
                this.$store.dispatch("toast/createToast", {
                  message: "There are no tenants associated with this user",
                });
              } else {
                this.handleError(err);
              }
            });
        } else {
          this.tenant_id = this.tenant_id ?? tenant_id;
          if (!this.tenant_id) {
            const [error, { data }] = await this.getTenants(email);
            if (error) {
              await this.$store.dispatch("toast/createToast", {
                message: "There are no tenants associated with this user",
              });
              return;
            }
            this.tenants = data;
            this.fieldsToShow = ["email", "tenants", "go back"];
            this.text = "Reset password";
            return;
          }
          await this.$store.dispatch("loader/show");
          try {
            LoginClient.reset({ email }, this.tenant_id).then(async () => {
              await this.$store.dispatch("loader/hide");
              this.isLoading = false;
              this.$buefy.dialog.alert({
                title: `Reset Link Sent`,
                confirmText: `I understand`,
                hasIcon: true,
                type: "is-primary",
                message: `A password reset link has been emailed to you. Please click the link and follow the steps as prompted. Remember to check your spam folder.`,
                onConfirm: () => {
                  this.$router.push("/login");
                },
              });
            });
          } catch {
            await this.$store.dispatch("loader/hide");
          }
        }
      },
    },
  };
</script>

<style scoped></style>
